import { Controller } from 'react-hook-form';

import {
  FormValidationErrorMessage,
  InputLabel,
  SelectFormInput
} from '@/components/atomic/nuclei';

const CheckoutEventDetail = ({
  clearErrors,
  control,
  errors,
  eventDetails,
  getValues,
  register,
  setValue
}) => {
  const options = eventDetails?.map((events) => ({
    id: events.id,
    name: events.event.name
  }));
  return (
    <>
      <div className='block md:flex md:items-center md:mb-4'>
        <div>
          <InputLabel
            {...{
              children: 'Choose the event you are planning for',
              className:
                'block text-sm md:text-base font-Montserrat text-nero font-medium'
            }}
          />
        </div>
        <div className='md:ms-3 pb-1.5'>
          {errors?.checkoutEventId && (
            <FormValidationErrorMessage
              {...{ message: 'Please choose event type.' }}
            />
          )}
        </div>
      </div>
      <div className='w-full relative mt-4 md:mt-0 checkout-event-type z-10'>
        {Boolean(eventDetails?.length) && (
          <Controller
            control={control}
            name='checkoutEventId'
            render={() => (
              <SelectFormInput
                {...{
                  clearErrors,
                  control,
                  dbName: 'checkoutEventId',
                  disabled: false,
                  errors,
                  getValues,
                  name: 'Checkout Event Id',
                  placeholderLabel: 'Event Type',
                  register,
                  setValue,
                  showErrors: false,
                  values: options
                }}
              />
            )}
            rules={{ required: 'Please choose an event type.' }}
          />
        )}
      </div>
    </>
  );
};

export default CheckoutEventDetail;
